import { useToggle } from '@village/tools';
import { FC, PropsWithChildren } from 'react';
import { EpionCheckinAppOptions } from 'types';

import { EpionCheckInForm } from './components/form';
import { EpionCheckInHeader } from './components/header';
import { TermsOfUseModal } from './components/terms-of-use-modal';
import { Welcome } from './components/welcome';
import * as Styled from './styles';

interface Props {
    options: EpionCheckinAppOptions;
}

export const EpionCheckIn: FC<PropsWithChildren<Props>> = ({ options }) => {
    const { value: started, switchOn: start } = useToggle(false);
    const { value: policyModalOpen, switchOn: openModal, switchOff: closeModal } = useToggle(false);
    const page = started ? 'intakeForm' : 'welcome';

    return (
        <Styled.Container>
            <EpionCheckInHeader page={page} />
            <Styled.FormWrapper>
                {page === 'welcome' ? (
                    <Welcome onStart={start} />
                ) : (
                    <EpionCheckInForm options={options} onTermsOfUseModalOpen={openModal} />
                )}
            </Styled.FormWrapper>
            <TermsOfUseModal open={policyModalOpen} onClose={closeModal} />
        </Styled.Container>
    );
};
